import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FeatureFlagsModule } from '@wilson/feature-flags';
import {
  ShiftScoreName,
  ShiftSmartScoreName,
  UserTimelinesModal,
} from '@wilson/interfaces';
import { ScoreMap, SmartScoreMap } from '@wilson/shift/core';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { ProductivityScoreDisplayComponent } from './productivity-score-display/productivity-score-display.component';
import { ScoreBarComponent } from './score-bar/score-bar.component';
import { TooltipPrefScoreBreakdownComponent } from './tooltip-pref-score-breakdown/tooltip-pref-score-breakdown.component';
import { TooltipSmartScoreBreakdownComponent } from './tooltip-smart-score-breakdown/tooltip-smart-score-breakdown.component';

@Component({
  selector: 'wilson-user-timeline-info-scores',
  templateUrl: './user-timeline-info-scores.component.html',
  styleUrls: ['./user-timeline-info-scores.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    NzTooltipModule,
    ScoreBarComponent,
    FeatureFlagsModule,
    TranslatePipe,
    NzSkeletonModule,
    TooltipPrefScoreBreakdownComponent,
    TooltipSmartScoreBreakdownComponent,
    ProductivityScoreDisplayComponent,
  ],
})
export class UserTimelineInfoScoresComponent {
  @Input() userTimeline!: UserTimelinesModal;
  @Input() prefScores!: ScoreMap | null;
  @Input() smartScores!: SmartScoreMap | null;
  @Input() hasFinishedLoadingScores!: boolean | null;
  @Input() size: 'small' | 'large' = 'small';

  ShiftScoreName = ShiftScoreName;
  ShiftSmartScoreName = ShiftSmartScoreName;
}
